import { getGlobalProperty } from "./getGlobalProperty";
import { getWindow } from "./getWindow";
export var getLocation = function() {
    var _getWindow;
    var _getGlobalProperty;
    return (_getGlobalProperty = getGlobalProperty("location")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location;
};
export var getLocationOrThrow = function() {
    var location = getLocation();
    if (!location) {
        throw new Error("Unable to resolve window.location");
    }
    return location;
};
